import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


// It is used to define our endpoints and allow to create the API slice
export const countriesApi = createApi({
  // The unique key that defines where the Redux store will store our cache.
  reducerPath: 'countriesApi',

  // The base query to request data.
  // RTK Query ships with fetchBaseQuery, which is a lightweight fetch wrapper that automatically handles request headers and response parsing in a manner similar to common libraries like axios.
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Countries'],
  keepUnusedDataFor: 86400000,
  refetchOnMountOrArgChange: 1,
  // The set of operations that we want to perform against the server.
  endpoints: (builder) => ({
    getAllCountries: builder.query({
      query: (data) => ({
        url: `countries?page=${data.page}&size=${data.size}&searchid=${data.searchquery && data.searchquery}`,
        method: 'GET',
        headers: {
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      keepUnusedDataFor: 86400000,
      providesTags: ['Countries'],
    }),

    deleteCountries: builder.mutation({
      query: (data) => {
        return {
          url: `countries/${data.id}`,
          method: 'DELETE',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
    keepUnusedDataFor: 86400000,
    invalidatesTags: ['Countries'],
    }),

    createCountries: builder.mutation({
      query: (data) => ({
        url: `countries`,
        method: 'POST',
        body: data,
        headers: {
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['Countries'],
    }),

    updateCountries: builder.mutation({
      query: (data) => ({
        url: `countries/${data.id}`,
        method: 'PUT',
        body: data,
        headers: {
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['Countries'],
    }),

  }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useGetAllCountriesQuery, useDeleteCountriesMutation, useCreateCountriesMutation, useUpdateCountriesMutation } = countriesApi